export var mobileGradientOverlay = '$_1fiFi';